import { render, staticRenderFns } from "./maquinas.vue?vue&type=template&id=a210256e&scoped=true"
import script from "./maquinas.vue?vue&type=script&lang=js"
export * from "./maquinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a210256e",
  null
  
)

export default component.exports